import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { NotificationMessageResource } from "@exonn/js-sdk";

export const module: ModuleOptions<NotificationMessageResource> = {
  resource: ResourceEnum.NotificationMessage,
  bigIcon: <span className={"icon-20-out_email"} />,
  smallIcon: <span className={"icon-15-out_email"} />,
  // Журнал: сообщения создаёт система, здесь их только смотрят.
  disableCreate: true,
  disableDelete: true,
  tabs: { edit: { getTitle: (message) => message.recipient } },
};
